import script from "./ProfessionalExperience.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalExperience.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalExperience.vue?vue&type=style&index=0&id=08f42f62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f42f62"]])

export default __exports__